export const StorageKey = {
  WEAK_AUTH_TOKEN: 'weak-auth-token',
  AUTH_TOKEN: 'auth-token',
  GET_STARTED: 'get-started',
  ENTITY_REGION: 'entity-region',
  SELECTED_ENTITY_URI: 'selected-entity-uri',
  PREFERRED_ENTITY_URI: 'preferred-entity-uri'
};
